import React, { memo, useCallback } from 'react';

import { RadioGroupCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { WORKSHEET_YES_NO_OPTIONS, WORKSHEET_YES_NO_VALUE } from './WorksheetYesNoField.constants';
import { toYesNoRadioValue } from './WorksheetYesNoField.utils';

/**
 * A Yes/No question as two radio options instead of a checkbox, so an unanswered question stays
 * empty instead of reading as "No". Saves a boolean, like the checkbox it replaces.
 */
const WorksheetYesNoField = ({
  id,
  name,
  value = null,
  isRequired = false,
  disabled = false,
  error = null,
  setInForm,
  validateField,
}) => {
  const onChange = useCallback(
    e => {
      const answer = e.target.value === WORKSHEET_YES_NO_VALUE.YES;

      setInForm(id, answer);
      validateField(id, answer);
    },
    [id, setInForm, validateField],
  );

  return (
    <RadioGroupCDS
      row
      className="mb-16"
      dataTestId={`worksheet-yes-no.${id}`}
      disabled={disabled}
      error={!!error}
      helperText={error ?? ''}
      label={name}
      name={id}
      options={WORKSHEET_YES_NO_OPTIONS}
      required={isRequired}
      value={toYesNoRadioValue(value)}
      onChange={onChange}
    />
  );
};

WorksheetYesNoField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setInForm: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  value: PropTypes.bool,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

export default memo(WorksheetYesNoField);
